import { Component, OnInit } from '@angular/core';
import { ConsignmentService } from '../../services/consignment.service';
import { ConsignmentProductService } from '../../services/consignment-product.service';
import { ProductService } from '../../../products/services/product.service';
import { ConsignmentStatusService } from '../../services/consignment-status.service';
import { ProductConsignmentStatusService } from '../../services/product-consignment-status.service';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { ConsignmentPaymentService } from '../../services/consignment-payment.service';
import { Observable } from 'rxjs/Observable';
declare let alasql;


declare var JSZip: any;
declare var JSZipUtils: any;
declare var Docxtemplater: any;
declare var ImageModule: any;
import * as FileSaver from 'file-saver';

import * as _ from 'lodash/lodash';

@Component({
  selector: 'app-list-consignment-payments',
  templateUrl: './list-consignment-payments.component.html',
  styleUrls: ['./list-consignment-payments.component.css'],
  providers:[ConsignmentPaymentService]
})
export class ListConsignmentPaymentsComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  role:number = 3;
  consignmentPayments:any = [];

  constructor(private consignmentPaymentService:ConsignmentPaymentService) { }

  ngOnInit() {
      try{
        this.role = JSON.parse(localStorage.getItem('user')).role; 
        this.getConsignmentPayments() ;
      }catch(e){
      }
  }

  getConsignmentPayments(){
    var params = {
      skip: (this.p-1)*10,
      limit: 10,
      sort: 'id DESC'
    };
    this.consignmentPaymentService.query(params)
      .subscribe((consignments) => {
        this.consignmentPaymentService.count({})
          .subscribe((count) => {
            this.totalItems = count.count;
          });
          this.consignmentPayments = consignments;
      });
  }

  deletePayment(id){
    this.consignmentPaymentService.delete(id)
      .subscribe(() => {
        this.getConsignmentPayments();
      });
  }

  parseProducts(payment){
    let description = "";
    let data = JSON.parse(payment.document_data);
    if (data && data.docData && data.docData.tpvs){
      data.docData.tpvs.forEach(e=>{
        description += e.barcode + " - " + e.name + ", ";
      })
      description = description.substring(0, description.length - 2);
    }
    return description;
  }

  downloadPay(payment){
    var opts = {
      centered : false,
      getImage: function(image){
        return image;
      },
    
      getSize: function() {
        return [300,204];
      }
    }

    var imageModule=new ImageModule(opts);
  
    this.loadFile("assets/template_pago_depositante.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
      let docData = JSON.parse(payment.document_data);
      docData.docData.total = payment.amount;
      docData.docData.num = payment.id;
      doc.setData(docData.docData);
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'pago_depositante.docx');  
      //_this.markAsPrinted();     
    })
  }

  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
  }

}



// WEBPACK FOOTER //
// ./src/app/consignment/components/list-consignment-payments/list-consignment-payments.component.ts